import React from "react";
import { Container } from "reactstrap";
import BreadCrumb from "Components/Common/BreadCrumb";
import AllAgencyContracts from "./AllAgencyContracts";
import { useProfile } from "Components/Hooks/UserHooks";
import { usePageActivity } from "Components/Hooks/UsePageActivity";
import { useLocation } from "react-router-dom";

const Contracts = () => {
  const location = useLocation();
  const { userProfile } = useProfile();
  usePageActivity(location.pathname, "Agency Contracts");

  document.title = `${userProfile?.agency?.name || ""} Contracts | CIMS`;
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={`${userProfile?.agency?.name || ""} Contracts`}
            pageTitle="Dashboard"
          />

          <AllAgencyContracts
            isViewContractors={false}
            isAgencyDashboard={false}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Contracts;
